import { useEffect } from 'react';
import i18n from '../i18n/config';

/**
 * Hook that syncs i18n language with the provided locale.
 * Call this once at your app's root level with the session locale.
 *
 * @param locale - The locale string (e.g., 'en-US', 'it-IT')
 */
export function useLocaleSync(locale: string | undefined): void {
  useEffect(() => {
    if (locale) {
      const lang = locale.split('-')[0];
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
    }
  }, [locale]);
}
